export default {
    selectors: ['[data-anchor-scroll]', '[data-smooth-scroll]'],
    gap: 40,

    init() {
        document.addEventListener('click', this.handleDocumentClick.bind(this));
    },

    handleDocumentClick(event) {
        const trigger = event.target.closest(this.selectors.join(', '));
        if (!trigger) return;

        const href = trigger.getAttribute('href');
        if (!href || !href.startsWith('#')) return;

        const target = document.querySelector(href);
        if (!target) return;

        event.preventDefault();
        this.scrollToTarget(target);
    },

    scrollToTarget(target) {
        const destination = this.getOffsetTop(target) - this.getFixedHeights() - this.gap;
        window.scrollTo({
            top: destination,
            behavior: 'smooth',
        });
    },

    getOffsetTop(target) {
        const rect = target.getBoundingClientRect();
        return rect.top + window.scrollY;
    },

    getFixedHeights() {
        const header = document.querySelector('.header-wrapper');
        const adminBar = document.getElementById('wpadminbar');

        const headerHeight = header ? Math.round(header.offsetHeight) : 0;
        const adminBarHeight = adminBar ? adminBar.offsetHeight : 0;

        return headerHeight + adminBarHeight;
    },
};
